export default __webpack_public_path__ + "static/media/blog-hillside-retaining-banner.9fdb7e31.jpeg";